module.exports = __webpack_public_path__ + "fonts/400-italic-cyrillic-ext.8bda115.woff2";